import React, { useEffect, useRef, useState } from "react"
import Esign from "../Esign"
import useToggle from "../../../../hooks/toggle";
import { selecteddocumentesign } from "../ReviewDocs";
import { useReactToPrint } from "react-to-print";
import { getexternaldocuments, getSavedOfferDetails, sendpurchasedocument } from "../../../../api/transaction";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import purgeStoredState from "redux-persist/es/purgeStoredState";
import { CSpinner } from "@coreui/react";
import { PURCHASE_AGREEMENT } from "../StaticHtmlTemplate";
const ReqPurchaseAggrement = () => {
    const params: { id: any, user: string } = useParams()
    const { id, user } = params
    const [puchaseaggrement, setPurchaseAgreement] = useState({
        offer_id: id,
        offer_date: "",
        property_address: "",
        city: "",
        state: "",
        zipcode: "",
        legal_description: "",
        country: "",
        range: false,
        oven: false,
        refrigerator: false,
        microwave: false,
        dishwasher: false,
        allwindow_coverings: false,
        allwindow_coveringhardware: false,
        alllight_fixtures: false,
        washer: false,
        dryer: false,
        alltv_mounts: false,
        garagedoor_opener: false,
        garagedoor_openerwith: "",
        storageshed: false,
        workbench: false,
        securitycameras: false,
        videodoorbells: false,
        digitalsmart: false,
        shelvinglocated: false,
        shelvinglocatedin: "",
        listinspace: "",
        warrantydeedor: "",
        noexceptions: false,
        excepts: false,
        exceptvalue: "",
        amountof: "",
        dollar: "",
        earnest_money: "",
        delivered_withthis_agreement: false,
        tobedelivered_later: false,
        delivered_within: "",
        escrowagent: false,
        purchaser_broker: false,
        seller_broker: false,
        seller_delivered: false,
        seller_deliveredby: "",
        seller_delivered_date: "",
        seller_delivered_receivedby: "",
        seller_delivered_receiveddate: "",
        all_cash: false,
        conditional_upon_financing: false,
        termsof_financing: false,
        termsof_financing_amountof: "",
        va: false,
        fha: false,
        conventional: false,
        usda: false,
        usda_value: "",
        checks: false,
        per_annum: "",
        year: "",
        seller_financing: false,
        loan_assumption: false,
        financingwithin_five: "",
        // 8.2.2 Purchaser Loan Application Requirements
        company_name: "",
        loan_officer_name: "",
        phone_no: "",
        contingentupon_saleandclosing: false,
        tobe_listed: false,
        tobe_listedby_value: "",
        locatedat: "",
        seeattached_addendum: false,
        purchaser_property_locatedat: "",
        closeon_approximately_date: "",
        closing: false,
        possession: false,
        possession_or: false,
        possession_or_value: "",

        // 12.1 Title Insurance Agent and Elections
        title_chk1: false,
        title_chk1_value: "",
        title_chk2: false,
        title_chk2_value: "",
        title_chk3: false,
        title_chk3_value: "",
        title_chk4: false,
        title_chk4_value: "",
        title_chk5: false,
        title_chk5_value: "",
        // 12.3 Closing and Closing Date.
        closingdate_shallbe: "",
        closingdate: "",
        ispossessiondate: false,
        closingdateor: false,
        closingdateor_value: "",

        //14 Escrow Agent
        escrow_chk1: false,
        escrow_chk1_value: "",
        escrow_chk2: false,
        escrow_chk2_value: "",
        escrow_chk3: false,
        escrow_chk3_value: "",
        //15 survey
        survey_chk1: false,
        survey_chk2: false,
        survey_chk3: false,
        survey_chk4: false,
        // 16 Home Warranty Acknowledgment
        home_warranty_chk1: false,
        home_warranty_chk2: false,
        home_warranty_chk3: false,
        home_warranty_chk4: false,
        home_warranty_chk4_value: false,
        home_warranty_chk5: false,
        home_warranty_chk6: false,
        cost_is: "",
        home_warranty_chk7: false,
        home_warranty_chk7_value: "",
        home_warranty_chk8: false,
        home_warranty_chk8_value: "",
        home_warranty_chk9: false,
        home_warranty_chk9_value: "",
        home_warranty_chk10: false,
        // 17 Wood Infestation
        wood_chk1: false,
        wood_chk1_value: "",
        wood_chk2: false,
        wood_chk2_value: "",
        wood_chk3: false,
        wood_chk3_value: "",
        wood_chk4: false,
        wood_chk5: false,
        wood_chk5_value: "",

        //18 Property Inspections
        property_inspection_chk1: false,
        property_inspection_chk1_value: "",
        property_inspection_chk2: false,
        property_inspection_chk2_value: "",

        // 25.2 Lead Based Paint
        is_lead_based: false,

        // 25.3 SID
        is_sid: false,
        sid_statement: "",

        // 30. Compensation of Selling Broker

        sellingbroker_compensationof: "",

        // 32 Offer Expiration
        offer_expiration_date: "",
        offer_expiration_at: "",
        offer_expiration_clock: "",
        m_prevailing_localtime: "",
        // THIS CONTRACT CONTAINS AN ARBITRATION PROVISION UNLESS WAIVED IN SECTION 31 WHICH MAY BE ENFORCED BY THE PARTIES.
        purchaser1: "",
        purchaser1_name_printed: "",
        purchaser1_address: "",
        purchaser1_city: "",
        purchaser1_state: "",
        purchaser1_zip: "",
        purchaser1_phone: "",
        purchaser2: "",
        purchaser2_name_printed: "",
        purchaser2_address: "",
        purchaser2_city: "",
        purchaser2_state: "",
        purchaser2_zip: "",
        purchaser2_phone: "",
        // NAMES FOR DEED(Purchaser retains the right to change prior to Closing)
        nameof_deed: "",

        nameof_deed_status: "",

        // PURCHASER AGENT INFO
        realtor_company_name: "",
        office_address: "",
        office_mls_id: "",
        office_phone: "",
        agent_name: "",
        agent_email: "",
        agent_mls_id: "",
        agent_phone: "",
        // SELLER ACCEPTANCE

        offer_puchaseon: "",
        offer_puchaseon_year: "",
        offer_puchaseon_oclock: "",
        offer_puchaseon_m_prevailing_localtime: "",
        comments: "",
        // THIS CONTRACT CONTAINS AN ARBITRATION PROVISION IN SECTION 31 UNLESS WAIVED WHICH MAY BE ENFORCED BY THE PARTIES.
        seller1: "",
        seller2: "",
        seller1_name: "",
        seller2_name: "",
        seller_status: "",

        // SELLER AGENT INFO

        selleragentinfo_companyname: "",
        selleragentinfo_officeaddress: "",
        selleragentinfo_mlsid: "",
        selleragentinfo_phone: "",
        selleragentinfo_agentname: "",
        selleragentinfo_agentemailaddress: "",
        selleragentinfo_agentmlsid: "",
        selleragentinfo_agentphone: "",

        // PURCHASER ACCEPTANCE OF COUNTER OFFER
        purchaseacceptance_date: "",
        purchaseacceptance_year: "",
        purchaseacceptance_colck: "",
        purchaseacceptance_m_prevailingtime: "",
        purhcaseacceptance_comments: "",

        // THIS CONTRACT CONTAINS AN ARBITRATION PROVISION IN SECTION 31 UNLESS WAIVED WHICH MAY BE ENFORCED BY THE PARTIES.

        purhcaser_acceptance_puchaser1: "",
        purhcaser_acceptance_puchaser2: "",
        purhcaser_acceptance_puchaser1_name: "",
        purhcaser_acceptance_puchaser2_name: "",

        // SELLER ACCEPTANCE OF COUNTER OFFER
        seller_acceptance_puchaser1: "",
        seller_acceptance_puchaser2: "",
        seller_acceptance_puchaser1_name: "",
        seller_acceptance_puchaser2_name: "",
    })
    const [loader, setloading] = useState(false)
    const componentRef = useRef();
    const [canvasmodal, setCanvasModal] = useToggle(false);
    const [htmlContent, setHtmlContent] = useState("");
    const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
        offerid: "",
        document_name: "",
        image_base64: "",
        sign_role: 1
    })
    const [offerdetails, setOfferDetails]: any = useState({});
    const printf = () => {
        handlePrint()
    };
    // @ts-ignore
    const val = useSelector((state) => state?.new?.signset)
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

useEffect(()=>{
if(val){
    if(user == "seller"){
        setPurchaseAgreement({ ...puchaseaggrement, seller1: val })
    }
    if(user == "client"){
        setPurchaseAgreement({ ...puchaseaggrement, purchaser1: val })
    }
}
},[val])



    const send = async () => {
        
        setloading(true)
        if (user === "seller") {
            // const run = async () => { return setPurchaseAgreement({ ...puchaseaggrement, seller1: val }) }
            // await run()
            if (puchaseaggrement?.seller1) {
                const res:any = await sendpurchasedocument(puchaseaggrement)
                
                if(res?.status == "success"){
                    alert("Submitted Successfully")
                }
                else{
                    alert("Something went wrong")
                }
            }
        } else if (user === "client") {
            // const run = async () => { return setPurchaseAgreement({ ...puchaseaggrement, purchaser1: val }) }
            // await run()
            if (puchaseaggrement?.purchaser1) {
                const res:any = await sendpurchasedocument(puchaseaggrement)
                if(res?.status == "success"){
                    alert("Submitted Successfully")
                }
                else{
                    alert("Something went wrong")
                }
            }
        }
        setloading(false)
    }


    useEffect(() => {
        (async function () {
            let offerdetails = await getSavedOfferDetails(id)
            setOfferDetails(offerdetails[0])
            const res =await getexternaldocuments(id,"purchaseagreement") 
            setPurchaseAgreement({...puchaseaggrement,
                purchaser1:res?.data?.purchaser1,
                seller1:res?.data?.seller1
            })
        })()

    }, [])

    function numberToWords(num: any) {
        const a = [
            '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'
        ];
        const b = [
            '', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'
        ];

        const numToWords = (n: any) => {
            if (n < 20) return a[n];
            if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
            if (n < 1000) return a[Math.floor(n / 100)] + ' hundred' + (n % 100 ? ' ' + numToWords(n % 100) : '');
            if (n < 100000) return numToWords(Math.floor(n / 1000)) + ' thousand' + (n % 1000 ? ' ' + numToWords(n % 1000) : '');
            if (n < 10000000) return numToWords(Math.floor(n / 100000)) + ' lakh' + (n % 100000 ? ' ' + numToWords(n % 100000) : '');
            return numToWords(Math.floor(n / 10000000)) + ' crore' + (n % 10000000 ? ' ' + numToWords(n % 10000000) : '');
        };

        return numToWords(num);
    }

    return (
        <>
            <meta charSet="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
            <link
                href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600&display=swap"
                rel="stylesheet"
            />
            <style
                dangerouslySetInnerHTML={{
                    __html:
                        '\n        * {\n            font-family: "Poppins", sans-serif;\n        }\n    '
                }}
            />
            <title>Document</title>
            <div ref={componentRef}>

                <section>
                    <table style={{ "width": "1100px", "margin": "0 auto", "background": "#fff", "padding": "15px" }}>
                        <tbody><tr>
                            <td>
                                <table style={{width: '100%'}}>
                                    <tbody><tr>
                                        <td><img style={{ width: "250px" }} src="https://storagemilforddev.blob.core.windows.net/images/logo.svg" /></td>
                                        <td style={{ textAlign: "center", fontWeight: "bold", paddingLeft: "30px" }}>GREAT PLAINS REGIONAL
                                            MLS
                                            <br /> LLC UNIFORM PURCHASE AGREEMENT
                                            <br/>
                                            <span style={{paddingTop: "30px", fontWeight: 500}}>(This is a legally binding
                                                        contract.
                                                        If not understood, seek legal advice.)</span>
                                        </td>
                                        <td style={{ paddingLeft: "30px" }}>
                                            <img style={{ "width": "40px", marginRight: 15 }} src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg" alt="1" />
                                            <img style={{ "width": "50px" }} src="https://storagemilforddev.blob.core.windows.net/images/eh.svg" alt="1" />
                                        </td>
                                        
                                    </tr>
                                    </tbody></table>
                            </td>
                        </tr>
                            <tr>
                                <td>
                                    <div style={{ marginTop: "5px" }}>
                                        <span style={{ fontWeight: 500 }}>The REALTOR® negotiating this agreement is a member of the
                                            National Association of REALTORS®
                                            and as such is governed by the applicable Code of Ethics and Rules of Fair Business
                                            Practice.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span><input type="text" defaultValue="Milford Real Estate" style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "450px" }} />
                                            <span style={{ fontWeight: 600 }}>
                                                REALTORS®
                                            </span> (Broker)<span style={{ fontWeight: 600, paddingLeft: "30px" }}>
                                                Date:
                                                {/* @ts-ignore  */}
                                            </span> <input type="date" value={offerdetails?.offerDate}
                                                // onChange={(e) => { setPurchaseAgreement({ ...puchaseaggrement, offer_date: e.target.value }) }}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} />
                                            (“Date of Offer”)<br /> The undersigned Purchaser, (whether one or more) agrees to purchase
                                            the
                                            Property described as follows:</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>1.</span>
                                        <span style={{ fontWeight: 600 }}> Property Address:</span>
                                        <span> <input type="text"
                                            // @ts-ignore  
                                            value={offerdetails?.propertyAddress}
                                            // onChange={(e) => { setPurchaseAgreement({ ...puchaseaggrement, property_address: e.target.value }) }}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "230px" }} /></span>

                                        <span style={{ fontWeight: 600 }}> ZipCode:</span>
                                        <span> <input type="text"
                                            value={puchaseaggrement?.zipcode} onChange={(e) => { setPurchaseAgreement({ ...puchaseaggrement, zipcode: e.target.value }) }}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "150px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>2.</span>
                                        <span style={{ fontWeight: 600 }}> Legal Description (Property):</span>
                                        <input type="text"   // @ts-ignore  
                                            value={offerdetails?.legal_description}
                                            //  onChange={(e) => { setPurchaseAgreement({ ...puchaseaggrement, legal_description: e.target.value }) }}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "780px" }} />
                                        <span>as surveyed, platted and recorded in</span>
                                        <input type="text" // @ts-ignore  
                                            value={offerdetails?.county} onChange={(e) => { setPurchaseAgreement({ ...puchaseaggrement, country: e.target.value }) }}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "250px" }} />
                                        <span style={{ fontWeight: 600 }}>County:</span>
                                        <input type="text" // @ts-ignore  
                                            value={offerdetails?.state}
                                            //   onChange={(e) => { setPurchaseAgreement({ ...puchaseaggrement, state: e.target.value }) }}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "150px" }} />
                                        <span style={{ fontWeight: 600 }}>State</span>
                                        <span>including all fixtures and equipment permanently attached to the Property.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>3.</span>
                                        <span style={{ fontWeight: 600 }}> Personal Property:</span>
                                        <span>The only personal property included is as follows</span>
                                        <span>
                                            range: "",
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Range")} />
                                            Range
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Oven")}
                                            />
                                            oven
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Refrigerator")}
                                            />
                                            refrigerator
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Microwave")}
                                            />
                                            microwave
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Dishwasher")} />
                                            dishwasher
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "all_window_covering")}
                                            />
                                            All Window Coverings
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "all_window_hardware")}
                                            />
                                            All window covering hardware
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "All Light Fixtures")}
                                            />
                                            All light fixtures
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Washer")}
                                            />
                                            washer
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Dryer")}
                                            />
                                            dryer
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "All TV mounts")}
                                            />
                                            all TV Mounts
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Garage Door Openers")}
                                            />
                                            garage door opener(s) with
                                            <input type="text"
                                                value={puchaseaggrement?.garagedoor_openerwith} onChange={(e) => { setPurchaseAgreement({ ...puchaseaggrement, garagedoor_openerwith: e?.target.value }) }}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "50px" }} />
                                            remotes
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Storage Shed")}
                                            />
                                            storage shed
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Work Bench")}
                                            />
                                            work bench
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Security Cameras")}
                                            />
                                            security cameras (unless rented)
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Video Doorbells")}
                                            />
                                            video doorbells
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Digital/Smart Thermostat ")}
                                            />
                                            digital/smart thermostats and light switches
                                        </span>
                                        <span>
                                            <input type="checkbox"
                                                checked={offerdetails?.property_to_stay?.find((e) => e == "Shelving")}
                                            />
                                            shelving located in
                                        </span>
                                        <span>
                                            <input type="text"
                                                value={puchaseaggrement?.shelvinglocatedin} onChange={(e) => { setPurchaseAgreement({ ...puchaseaggrement, shelvinglocatedin: e?.target?.value }) }}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "250px" }} />
                                            other (list in space),
                                            <input type="text"
                                                value={puchaseaggrement?.listinspace} onChange={(e) => { setPurchaseAgreement({ ...puchaseaggrement, listinspace: e?.target?.value }) }}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "665px" }} />
                                            all as in place at the time of showing of the Property together with any other property
                                            which is
                                            permanently affixed to the Property.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>4.</span>
                                        <span style={{ fontWeight: 600 }}> Conveyance: </span>
                                        <span>Provided that the Seller (whether one or more) has good, valid and marketable title, in
                                            fee
                                            simple, Seller agrees to convey title to Property to Purchaser or his nominee by form of
                                            warranty deed or </span>
                                        <input type="text"
                                            value={puchaseaggrement?.warrantydeedor} onChange={(e) => { setPurchaseAgreement({ ...puchaseaggrement, warrantydeedor: e?.target?.value }) }}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "150px" }} />
                                        <span>
                                            , free and clear of all liens, encumbrances or special taxes levied or assessed,
                                            <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.no_exception}
                                            />
                                            no exceptions
                                            <input type="checkbox"  // @ts-ignore  
                                                checked={puchaseaggrement?.no_report}
                                            />
                                            except
                                            <input type="text"
                                                value={puchaseaggrement?.exceptvalue} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, exceptvalue: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} />
                                        </span>
                                        <span>and subject to all building and use restrictions, utility easements abutting the boundary
                                            of
                                            the Property, and protective covenants now of record.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>5.</span>
                                        <span style={{ fontWeight: 600 }}>Assessments: </span>
                                        <span>
                                            Within five (5) calendar days of the execution of this Agreement, Seller agrees to provide
                                            notice to Purchaser of all public improvements related to the Property which have been
                                            ordered
                                            but not yet commenced and shall timely supplement such information as new or updated
                                            information
                                            or improvements become known to Seller prior to Closing. After receiving Notice under this
                                            Section from Seller, Purchaser may terminate this Agreement within five (5) calendar days of
                                            such notice. Except as agreed between Purchaser and Seller, special assessments for public
                                            improvements not commenced as of Closing shall be the responsibility of Purchaser. Seller
                                            agrees
                                            to pay any special assessments for public improvements previously constructed or under
                                            construction as of Closing. For the purpose of this paragraph, public improvement shall mean
                                            improvements constructed by or on behalf of a government entity including, but not limited
                                            to,
                                            paving, curb, sidewalk and utilities.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>6.</span>
                                        <span style={{ fontWeight: 600 }}> Consideration: </span>
                                        <span>
                                            Purchaser agrees to pay to Seller, via certified funds, unless otherwise set forth in this
                                            Agreement, the total purchase price in the amount of
                                            <input type="text"  // @ts-ignore  
                                                value={offerdetails?.offer_price}
                                                //  onChange={(e)=>setPurchaseAgreement({...puchaseaggrement,amountof:e?.target.value})}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "450px" }} />
                                        </span>
                                        <span>DOLLARS
                                            ($ <input type="numnber"  // @ts-ignore  
                                                value={offerdetails?.offer_price}
                                                //  onChange={(e)=>setPurchaseAgreement({...puchaseaggrement,dollar:e?.target.value})}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "250px" }} />)</span>
                                        <span>
                                            on the following terms: $
                                            <input type="text"  // @ts-ignore  
                                                value={offerdetails?.earnest_deposit}
                                                //  onChange={(e)=>setPurchaseAgreement({...puchaseaggrement,earnest_money:e?.target.value})}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "250px" }} />
                                            (Earnest Money) deposited herewith as evidenced by the receipt below unless otherwise
                                            provided
                                            in Section 7, below, with the balance thereof, together with all other amounts required
                                            under
                                            this Agreement, to be paid at Closing.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>7.</span>
                                        <span style={{ fontWeight: 600 }}> Receipt and Delivery of Earnest Money: </span>
                                        <span>
                                            Earnest Money is made payable and delivered to as follows:<br />
                                            <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.delivered_aggrement}
                                            /> delivered with this Agreement <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.delivered_later}

                                            /> to be
                                            delivered later (If to be delivered later, see Section
                                            10) to be delivered within
                                            <input type="text" // @ts-ignore  
                                                value={offerdetails?.delivered_hour}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />
                                            hours of final acceptance of this Agreement. Earnest Money payable to.
                                        </span>
                                        <span><input type="checkbox"
                                            checked={puchaseaggrement?.escrowagent} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, escrowagent: !puchaseaggrement?.escrowagent })}
                                        />Escrow Agent</span>
                                        <span><input type="checkbox"
                                            checked={puchaseaggrement?.purchaser_broker} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, purchaser_broker: !puchaseaggrement?.purchaser_broker })}
                                        /> Purchaser Broker</span>
                                        <span><input type="checkbox"
                                            checked={puchaseaggrement?.seller_broker} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, seller_broker: !puchaseaggrement?.seller_broker })}
                                        />Seller Broker</span>
                                        <span><input type="checkbox"
                                            checked={puchaseaggrement?.seller_delivered} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, seller_delivered: !puchaseaggrement?.seller_delivered })}
                                        />Seller</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span>Delivered by: <input type="text"  // @ts-ignore  
                                            value={offerdetails?.delivered_by}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "250px" }} />
                                        </span>
                                        <span>Date: <input type="date" // @ts-ignore  
                                            value={offerdetails?.delivered_date}

                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} /></span>
                                        <span>Received by: <input type="text" // @ts-ignore  
                                            value={offerdetails?.received_by}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "250px" }} /></span>
                                        <span>Date: <input type="date"  // @ts-ignore  
                                            value={offerdetails?.received_date}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span>If the Earnest Money is paid by check, it will be cashed following acceptance of this
                                            Agreement or as otherwise agreed herein. In the event this offer is not accepted by the
                                            Seller of the Property within the time specified, the Earnest Money shall be returned to
                                            Purchaser. In the event there are any defects in the title which cannot be cured as
                                            specified below, the Earnest Money shall be paid to Purchaser. In the event</span>
                                    </div>
                                </td>
                            </tr> */}

                        </tbody></table>
                </section>
                <section>
                    <table style={{ "width": "1100px", "margin": "0 auto", "background": "#fff", "padding": "15px" }}>
                        <tbody>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px  0px" }}>
                                        <span>of wrongful refusal or failure of the Purchaser to consummate the purchase, the Seller
                                            may, at Seller’s option, demand or retain the Earnest Money for failure to carry out the
                                            terms of this Purchase Agreement and pursue the Purchaser for any damages in excess of such
                                            amount, subject to the terms of the listing agreement. If the Earnest Money is held by
                                            either Broker, it may be transferred to an Escrow Agent at any time, In the case of a
                                            dispute over the return or forfeiture of the Earnest Money, the holder of the Earnest Money
                                            may require the agreement of Seller and Purchaser to release the Earnest Money. The holder
                                            of the Earnest Money may pay any Earnest Money into court upon the filing of any legal
                                            action related thereto. Such legal action shall not be maintained against Broker when the
                                            dispute is between Purchaser and Seller. Any party naming Broker as a party to any
                                            proceeding despite the aforementioned sentences shall be liable to Broker for all legal fees
                                            and costs.</span>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>8.</span>
                                        <span style={{ fontWeight: 600 }}> Payment of Purchase Price. Purchaser shall pay the Purchase
                                            Price at Closing as follows (select one): </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ margin: "12px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span><input type="checkbox"  // @ts-ignore  
                                            checked={offerdetails?.all_cash}
                                        /> <span style={{ fontWeight: 600 }}>8.1 All Cash:</span>Balance of the
                                            Purchase Price, after accounting for the Earnest Money, shall be paid in wire transferred
                                            funds, or
                                            certified or cashier’s check at time of delivery of deed, no financing being required.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span><input type="checkbox"  // @ts-ignore  
                                            checked={offerdetails?.conditional_financing}
                                        /> <span style={{ fontWeight: 600 }}>8.2 Conditional Upon
                                            Financing</span>This Agreement shall be conditional upon Purchaser obtaining financing,
                                            under the terms set
                                            forth below:
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>PROPERTY ADDRESS:
                                            <input type="text"
                                                value={offerdetails?.propertyAddress}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "500px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>© 2021 GREAT PLAINS REGIONAL MLS, LLC<br />
                                            Page 5 of 10<br />
                                            2/1/2021 Form 200
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text"
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                              value={offerdetails?.lead_firstname?.charAt(0)?.toUpperCase() + offerdetails?.lead_lastname?.charAt(0)?.toUpperCase()}
                                            
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span><input type="checkbox"  // @ts-ignore  
                                            checked={offerdetails?.terms_financing}
                                        /> <span style={{ fontWeight: 600 }}>8.2.1 Terms of
                                            Financing.</span>Balance of the Purchase Price, after accounting for the Earnest Money,
                                            shall be paid in wire transferred funds, or by certified or cashier’s check at time of
                                            delivery of deed, conditioned upon Purchaser’s ability to obtain financing to be secured by
                                            first mortgage or deed of trust, on above described Property in the amount of $
                                            <input type="text"
                                                value={puchaseaggrement?.termsof_financing_amountof}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "300px" }} />The
                                            financing will be (select one)
                                            <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.buyer_finance_type == "VA" ? true : false}
                                            />VA,
                                            <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.buyer_finance_type == "FHA" ? true : false}
                                            />FHA, <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.buyer_finance_type == "Conventional" ? true : false}

                                            />CONVENTIONAL, <input type="checkbox"
                                            />USDA
                                            or <input type="checkbox"

                                            /> <input type="text"
                                                value={puchaseaggrement?.usda_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, usda_value: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "300px" }} />,
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.checks} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, checks: !puchaseaggrement?.checks })}
                                            />check here if loan to be NIFA
                                            qualified and for an initial interest rate not exceeding <input type="text"
                                                value={puchaseaggrement?.per_annum} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, per_annum: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "300px" }} />,%
                                            per annum, plus mortgage insurance. Financing will be for a period of not less than <input type="text"
                                                value={puchaseaggrement?.year} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, year: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "70px" }} />years.
                                            Loan origination/service fee to be paid by Purchaser except as otherwise agreed herein.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span><input type="checkbox"
                                            checked={puchaseaggrement?.seller_financing} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, seller_financing: !puchaseaggrement?.seller_financing })}
                                        /> <span style={{ fontWeight: 600 }}>Seller Financing: -</span>See
                                            attached addendum</span>
                                        <span style={{ paddingLeft: "30px" }}><input type="checkbox"
                                            checked={puchaseaggrement?.loan_assumption} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, loan_assumption: !puchaseaggrement?.loan_assumption })}
                                        /> <span style={{ fontWeight: 600 }}>Loan
                                            Assumption: - </span>See attached addendum.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span><span style={{ fontWeight: 600 }}>8.2.2 Purchaser Loan Application Requirements:
                                        </span>Purchaser agrees to make application for financing within five (5)
                                            <input type="text"
                                                value={puchaseaggrement?.financingwithin_five} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, financingwithin_five: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} /> or
                                            business days of acceptance of this offer to one or more of the following: </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span><input type="text"
                                            value={puchaseaggrement?.company_name} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, company_name: e?.target.value })}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", }} />,
                                            <span style={{ "padding": "15px 80px" }}>Company Name</span>
                                            or <input type="text"  // @ts-ignore  
                                                value={offerdetails?.lenderName} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, loan_officer_name: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", }} />
                                            <span style={{ "padding": "15px 80px" }}>Loan Officer Name</span>,
                                            <input type="text"
                                                value={puchaseaggrement?.phone_no} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, phone_no: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", }} /> <span style={{ "padding": "15px 80px" }}>Phone no</span></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span><input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "1000px" }} />,
                                            or <span style={{ "padding": "15px 80px" }}>Company Name</span> <span style={{ "padding": "15px 80px" }}>Loan Officer Name</span> <span style={{ "padding": "15px 80px" }}>Loan Officer Name</span></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span><input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "1000px" }} />.
                                            <span style={{ "padding": "15px 80px" }}>Company Name</span> <span style={{ "padding": "15px 80px" }}>Loan
                                                Officer Name</span> <span style={{ "padding": "15px 80px" }}>Loan Officer Name</span></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px" }}>
                                        <span>Purchaser agrees to provide verification to Seller that a loan application has been
                                            submitted, Purchaser agrees to close within original set closing date, or, if the loan has
                                            not been approved or denied prior to the Closing date, Closing shall be automatically
                                            extended until approval or denial is issued, subject to the terms of Section 13, below. Upon
                                            notification to Purchaser of a loan denial, Purchaser shall notify Seller of such denial
                                            within one (1) business day. Unless otherwise agreed by Purchaser and Seller, this Agreement
                                            shall be deemed null and void five
                                            (5) days following such notice to Seller.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>9.</span>
                                        <span style={{ fontWeight: 600 }}>SALE CONTINGENCY: (Check one if applicable): </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span> <input type="checkbox"
                                            checked={puchaseaggrement?.contingentupon_saleandclosing} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, contingentupon_saleandclosing: !puchaseaggrement?.contingentupon_saleandclosing })}
                                        /><span style={{ fontWeight: 600 }}>9.1 Contingent Upon Sale and
                                            Closing: </span>This offer is contingent upon the sale and closing of Purchaser’s
                                            property located at: <input type="text"  // @ts-ignore  
                                                value={offerdetails?.contingency_property_address}
                                            />(address)
                                            <input type="checkbox"

                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", }} />
                                            to be listed by
                                            <input type="text"
                                                value={puchaseaggrement?.locatedat} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, locatedat: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "400px" }} />
                                            brokerage
                                            <input type="text"
                                                checked={puchaseaggrement?.seeattached_addendum} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, seeattached_addendum: !puchaseaggrement?.seeattached_addendum })}
                                            />(agent) on or before
                                            <input type="date" /> (date).
                                            <input type="checkbox" name="" id="" />
                                            see attached addendum
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span> <input type="checkbox"

                                        /><span style={{ fontWeight: 600 }}>9.2 Contingent Upon Closing of
                                            Purchaser’s Property Currently Under Contract: </span>This offer is contingent upon
                                            Purchaser first obtaining the proceeds from the closing of the Purchaser’s property located
                                            at <input type="text"
                                                value={puchaseaggrement?.purchaser_property_locatedat} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaser_property_locatedat: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "400px" }} />scheduled
                                            to close on approximately <input type="date"
                                                value={puchaseaggrement?.closeon_approximately_date} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, closeon_approximately_date: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "350px" }} />(date).
                                        </span>
                                    </div>
                                </td>
                            </tr>


                        </tbody></table>
                </section>
                <section>
                    <table style={{ "width": "1100px", "margin": "0 auto", "background": "#fff", "padding": "15px" }}>
                        <tbody>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>Great Plains Regional MLS, LLC Uniform Purchase Agreement –
                                            Cont</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ textAlign: "justify" }}>If such closing does not occur on the closing date as
                                            scheduled, Closing Date shall be automatically extended until such contingent closing
                                            occurs. In the event that Closing Date is automatically extended pursuant to this section,
                                            the parties shall reasonably cooperate to schedule Closing on a date and time consistent
                                            with such extension. In the event that automatic extension of the Closing has delayed
                                            Closing by more than fourteen (14) calendar days, either Purchaser or Seller, upon written
                                            notice to the other, may declare this Agreement void, and the Earnest Money shall be
                                            returned to the Purchaser, less any and all costs which Purchaser is obligated to pay,
                                            including, but not limited to, costs of inspections and surveys ordered by or on behalf of
                                            Purchaser as invoiced to or made known to Escrow Agent.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>10.</span>
                                        <span style={{ fontWeight: 600 }}>Other Provisions </span>
                                        <span>(if attaching addenda, list in Section 33):</span>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <div>
                                        <span>
                                            <textarea // @ts-ignore  
                                                value={offerdetails?.other_provision}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "1050px" }}
                                            />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>11</span>
                                        <span style={{ fontWeight: 600 }}>Taxes:</span>
                                        <span>If the Property is located in <span style={{ fontWeight: 600 }}>Douglas or Sarpy County,
                                            Nebraska, </span>all consolidated real estate taxes which become delinquent in the year
                                            of Closing (as are typically paid in the year of Closing) are Current Taxes for the purposes
                                            of this Agreement. If the Property is located in any other county, all consolidated real
                                            estate taxes for the year in which Closing takes place (as are typically paid in the year
                                            following the year of Closing) are Current Taxes for the purposes of this Agreement (based
                                            on assessed value and tax rate as of the date of this Agreement). Such Current Taxes shall
                                            be prorated as of date of <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.closing == true ? true : false}
                                            />Closing, <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.possession == true ? true : false}
                                            />possession
                                            or <input type="checkbox"
                                                checked={puchaseaggrement?.possession_or} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, possession_or: !puchaseaggrement?.possession_or })}
                                            /><input type="text"
                                                value={puchaseaggrement?.possession_or_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, possession_or_value: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "150px" }} />.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>12</span>
                                        <span style={{ fontWeight: 600 }}>Conveyance of Title and Closing.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ paddingLeft: "20px" }}>
                                        <span><span style={{ fontWeight: 600 }}>12.1 Title Insurance Agent and Elections. </span>The Real
                                            Estate Settlement Procedures Act (“RESPA”) and its accompanying regulations make it clear
                                            that if the Purchaser pays any part of the title insurance policy, the Seller cannot make
                                            the sale conditioned on the use of a particular title insurance company. According to the
                                            Purchasers rights under RESPA, Purchaser hereby directs the title insurance work to
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.title_chk1} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, title_chk1: !puchaseaggrement?.title_chk1 })}
                                            /><input type="text"
                                                value="Nebraska Title"
                                                //  onChange={(e)=>setPurchaseAgreement({...puchaseaggrement,title_chk1_value:e?.target.value})}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} defaultValue="Nebraska Title" />,
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.title_chk2} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, title_chk2: !puchaseaggrement?.title_chk2 })}
                                            />
                                            <input type="text"
                                                value={puchaseaggrement?.title_chk2_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, title_chk2_value: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} />, or
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.title_chk3} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, title_chk3: !puchaseaggrement?.title_chk3 })}
                                            />
                                            <input type="text"
                                                value={puchaseaggrement?.title_chk3_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, title_chk3_value: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} />,Purchaser
                                            hereby selects the expanded ALTA Homeowners Policy of Title or
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.title_chk4} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, title_chk4: !puchaseaggrement?.title_chk4 })}
                                            />
                                            <input type="text"
                                                value={puchaseaggrement?.title_chk4_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, title_chk4_value: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} defaultValue="Basic" />, The cost
                                            of any title insurance policies and endorsements shall be equally divided between Purchaser
                                            and Seller or <input type="checkbox"
                                                checked={puchaseaggrement?.title_chk5} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, title_chk5: !puchaseaggrement?.title_chk5 })}
                                            /> <input type="text"
                                                value={puchaseaggrement?.title_chk5_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, title_chk5_value: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} />.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>PROPERTY ADDRESS:
                                            <input type="text"
                                                value={offerdetails?.propertyAddress}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "500px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>© 2021 GREAT PLAINS REGIONAL MLS, LLC<br />
                                            Page 5 of 10<br />
                                            2/1/2021 Form 200
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                              value={offerdetails?.lead_firstname?.charAt(0)?.toUpperCase() + offerdetails?.lead_lastname?.charAt(0)?.toUpperCase()}
                                            
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ paddingLeft: "20px" }}>
                                        <span><span style={{ fontWeight: 600 }}> 12.2. Title and Title Exceptions. </span>
                                            Seller shall through Seller’s Agent or Closing agent furnish a current title insurance
                                            commitment or complete abstract of title to Purchaser as soon as practical. If title defects
                                            are found, Seller must cure them within a reasonable time, and Closing shall be
                                            automatically extended until such defects are cured, in accordance with Section 13, below.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span><span style={{ fontWeight: 600 }}> 12.3 Closing and Closing Date. </span>
                                            “Closing Date” as used herein shall be <input type="text"
                                                value={puchaseaggrement?.closingdate_shallbe} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, closingdate_shallbe: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "400px" }} />,20

                                            <input type="date"
                                                value={puchaseaggrement?.closingdate} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, closingdate: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "50px" }} />, and
                                            possession date shall be <input type="checkbox"
                                                checked={puchaseaggrement?.ispossessiondate} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, ispossessiondate: !puchaseaggrement?.ispossessiondate })}
                                            />Closing Date, or <input type="checkbox"
                                                checked={puchaseaggrement?.closingdateor} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, closingdateor: !puchaseaggrement?.closingdateor })}
                                            />
                                            <input type="text"
                                                value={puchaseaggrement?.closingdateor_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, closingdateor_value: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "400px" }} /> ,
                                            20 . The time of the transfer of possession shall be as agreed upon by Purchaser and Seller,
                                            at a time not later than 4:00 PM on the day of Closing, but not before the time of Closing.
                                            At the time of transfer of possession, Seller shall leave the Property in broom-clean
                                            condition, free of any personal property not conveyed hereunder, and shall deliver all keys
                                            to the Property to Purchaser. “Closing” as used herein shall mean the event of the exchange
                                            of the Purchase Price for the deed to be conducted in accordance with Section 14, below.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>13</span>
                                        <span style={{ fontWeight: 600 }}> Delay and Extension of Closing. </span>
                                        <span>In the event that Closing Date as set forth in Section 12.3 is automatically extended
                                            pursuant to Section 8.2.2, 9.2, or 12.2 of this Agreement, the parties shall reasonably
                                            cooperate to schedule Closing on a date and time consistent with such extension. In the
                                            event that automatic extension of the Closing has delayed Closing by more than fourteen (14)
                                            calendar days, either Purchaser or Seller, upon written notice to the other, may declare
                                            this Agreement void, and the Earnest Money shall be returned to the Purchaser, less any and
                                            all costs which Purchaser is obligated to pay, including, but not limited to, costs of
                                            inspections and surveys ordered by or on behalf of Purchaser as invoiced to or made known to
                                            Escrow Agent. Purchaser and Seller release and agree to hold harmless all listing and
                                            selling brokers, title insurance companies, escrow agents and lenders, if any, together with
                                            their employees and associates, from and against any and all claims related to any delay in
                                            the occurrence of Closing.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>14</span>
                                        <span style={{ fontWeight: 600 }}> Escrow Closing: </span>
                                        <span>Purchaser and Seller acknowledge and understand that the Closing of the sale may be
                                            handled by an Escrow Agent and that the Broker is authorized to transfer the Earnest Money
                                            or any other funds it receives to said Escrow Agent. After said transfer, Broker shall have
                                            no further responsibility or liability to Purchaser or Seller for the accounting for said
                                            funds. Escrow Agent’s or the Broker’s charge for the escrow Closing shall be equally divided
                                            between Purchaser and Seller. The State Documentary Tax on the deed shall be paid.</span>
                                    </div>
                                </td>
                            </tr>

                        </tbody></table>
                </section>
                <section >
                    <table style={{ "width": "1100px", "margin": "0 auto", "background": "#fff", "padding": "15px" }}>
                        <tbody><tr>
                            <td>
                                <div>
                                    <span style={{ fontSize: "12px" }}>Great Plains Regional MLS, LLC Uniform Purchase Agreement –
                                        Cont</span>
                                </div>
                            </td>
                        </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span>by the Seller. Escrow Agent shall be <input type="checkbox"
                                            checked={puchaseaggrement?.escrow_chk1} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, escrow_chk1: !puchaseaggrement?.escrow_chk1 })}
                                        /> <input type="text"
                                            value={puchaseaggrement?.escrow_chk1_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, escrow_chk1_value: e?.target.value })}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "400px" }} defaultValue="Milford Closing, Jesse Diamond, (402) 492-2434, orders@milfordclosing.com  " />
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.escrow_chk2} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, escrow_chk2: !puchaseaggrement?.escrow_chk2 })}
                                            /> <input type="text"
                                                value={puchaseaggrement?.escrow_chk2_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, escrow_chk2_value: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "300px" }} /> , or
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.escrow_chk3} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, escrow_chk3: !puchaseaggrement?.escrow_chk3 })}
                                            /> <input type="text"
                                                value={puchaseaggrement?.escrow_chk3_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, escrow_chk3_value: e?.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "300px" }} />. If
                                            no Escrow Agent is selected, the title insurance agent, above, shall be the Escrow Agent. At
                                            Closing Purchaser shall make payment of all amounts due in good funds, as determined by the
                                            Escrow Agent.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontSize: "600", paddingRight: "20px" }}>15</span>
                                        <span style={{ fontSize: "600" }}>Survey: </span>
                                        <span>Purchaser is aware of the availability of having a survey to determine the property
                                            limits, measurements, building locations, encroachments from adjoining lands, and registered
                                            Easements which may affect the property. Purchaser may obtain and pay for one or more of the
                                            following.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span><input type="checkbox"
                                            checked={puchaseaggrement?.survey_chk1} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, survey_chk1: !puchaseaggrement?.survey_chk1 })}
                                        /> 1. <span style={{ textDecoration: "underline" }}>Improvement Location
                                            Survey / Plot Plan</span> (minimum survey; or relied upon for establishment of structure
                                            or other improvements),
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span><input type="checkbox"
                                            checked={puchaseaggrement?.survey_chk2} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, survey_chk2: !puchaseaggrement?.survey_chk2 })}
                                        /> 2. <span style={{ textDecoration: "underline" }}> Boundary and
                                            Improvement Location Survey</span> (corners located/verified; improvements located;
                                            parcel checked for encroachments, may be used for construction with regard to local, state
                                            and federal regulations),
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px", paddingRight: "20px" }}>
                                        <span><input type="checkbox"
                                            checked={puchaseaggrement?.survey_chk3} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, survey_chk3: !puchaseaggrement?.survey_chk3 })}
                                        /> 3. <span style={{ textDecoration: "underline" }}> ALTA (American Land
                                            Title Association) Survey </span> (most comprehensive survey, covers all aspects of
                                            above survey options and identifies any additional evidence of possession or use which could
                                            be adverse to Purchaser).
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px", paddingLeft: "20px" }}>
                                        <span><input type="checkbox"
                                            checked={puchaseaggrement?.survey_chk4} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, survey_chk4: !puchaseaggrement?.survey_chk4 })}
                                        /> 4. Waived if not required by lender
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600 }}>In most situations, even if a survey is not required, one of the
                                            surveys is recommended.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>16</span>
                                        <span style={{ fontWeight: 600 }}>Home Warranty Acknowledgment: </span>
                                        <span>Purchaser has been advised of the availability of Home warranty.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span><input type="checkbox"
                                            checked={puchaseaggrement?.home_warranty_chk1} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk1: !puchaseaggrement?.home_warranty_chk1 })}
                                        />
                                            Purchaser shall receive a home warranty, provided at the expense of
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.home_warranty_chk2} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk2: !puchaseaggrement?.home_warranty_chk2 })}
                                            />
                                            Purchaser <input type="checkbox"
                                                checked={puchaseaggrement?.home_warranty_chk3} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk3: !puchaseaggrement?.home_warranty_chk3 })}
                                            />
                                            Seller or <input type="checkbox"
                                                checked={puchaseaggrement?.home_warranty_chk4} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk4: !puchaseaggrement?.home_warranty_chk4 })}
                                            /><input type="text"  // @ts-ignore  
                                                value={puchaseaggrement?.home_warranty_chk4_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk4_value: !puchaseaggrement?.home_warranty_chk4_value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} />
                                            Purchaser selects the warranty type
                                            <input type="checkbox" // @ts-ignore  
                                                checked={offerdetails?.warranty_type == "Non-Evaluated" ? true : false}
                                            />
                                            Non-Evaluated Warranty <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.warranty_type == "Evaluated" ? true : false}
                                            />Evaluated Warranty (if available) with No Exclusions*. Cost is $_
                                            <input type="text"
                                                value={puchaseaggrement?.cost_is} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, cost_is: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} defaultValue={590} />plus applicable taxes. Home warranty plan benefits are limited to and
                                            defined by the plan documents, which Purchaser is advised to review. *(Seller is responsible
                                            to ensure issuance of warranty with no exclusions under this option.)Home warranty provider
                                            shall be <input type="checkbox"
                                                checked={puchaseaggrement?.home_warranty_chk7} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk7: !puchaseaggrement?.home_warranty_chk7 })}
                                            /> <input type="text"
                                                value={puchaseaggrement?.home_warranty_chk7_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk7_value: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "300px" }} defaultValue="HWA" />,
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.home_warranty_chk8} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk8: !puchaseaggrement?.home_warranty_chk8 })}
                                            />
                                            <input type="text"
                                                value={puchaseaggrement?.home_warranty_chk8_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk8_value: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "300px" }} defaultValue="HWA" />, or
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.home_warranty_chk9} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk9: !puchaseaggrement?.home_warranty_chk9 })}
                                            />
                                            <input type="text"
                                                value={puchaseaggrement?.home_warranty_chk9_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk9_value: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "250px" }} defaultValue="HWA" />.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span><input type="checkbox"
                                            checked={puchaseaggrement?.home_warranty_chk10} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, home_warranty_chk10: !puchaseaggrement?.home_warranty_chk10 })}
                                        />Home warranty coverage rejected by Purchaser.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>17</span>
                                        <span style={{ fontWeight: 600 }}> Wood Infestation: </span>
                                        <span> Purchaser (Seller, in the case of a new VA loan) agrees to pay the cost of a wood
                                            destroying insect inspection of the Property, and Seller agrees to pay for any treatment or
                                            repair work found necessary for issuance of a wood destroying insects warranty.Termite
                                            inspection work is to be performed by
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.wood_chk1} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, wood_chk1: !puchaseaggrement?.wood_chk1 })}
                                            />
                                            <input type="text"
                                                value={puchaseaggrement?.wood_chk1_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, wood_chk1_value: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "400px" }} />,
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.wood_chk2} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, wood_chk2: !puchaseaggrement?.wood_chk2 })}
                                            /><input type="text"
                                                value={puchaseaggrement?.wood_chk2_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, wood_chk2_value: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "400px" }} />,or
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.wood_chk3} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, wood_chk3: !puchaseaggrement?.wood_chk3 })}
                                            />
                                            <input type="text"
                                                value={puchaseaggrement?.wood_chk3_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, wood_chk3_value: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "400px" }} />,Purchaser
                                            agrees to accept the treated Property upon completion of repairs. Provided,
                                            however, if treatment and repairs exceed
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.wood_chk4} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, wood_chk4: !puchaseaggrement?.wood_chk4 })}
                                            /> 2% or
                                            <input type="checkbox"
                                                checked={puchaseaggrement?.wood_chk5} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, wood_chk5: !puchaseaggrement?.wood_chk5 })}
                                            /> <input type="text"
                                                value={puchaseaggrement?.wood_chk5_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, wood_chk5_value: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} />,of
                                            the purchase price, this Purchase Agreement may be cancelled
                                            by Seller and/or Purchaser, by written notice delivered to the other party within five (5)
                                            calendar days of receipt of a wood destroying insect inspection report. Such inspection
                                            report must be delivered to the Seller and Purchaser not later than ten (10) calendar days
                                            prior to the Closing Date, at which time Purchaser shall be paid the Earnest Money with no
                                            further agreement or release required.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>PROPERTY ADDRESS:
                                            <input type="text"
                                                value={offerdetails?.propertyAddress}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "500px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>© 2021 GREAT PLAINS REGIONAL MLS, LLC<br />
                                            Page 5 of 10<br />
                                            2/1/2021 Form 200
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                              value={offerdetails?.lead_firstname?.charAt(0)?.toUpperCase() + offerdetails?.lead_lastname?.charAt(0)?.toUpperCase()}
                                            
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>18</span>
                                        <span style={{ fontWeight: 600 }}> Property Inspections: </span>
                                        <span>
                                            Purchaser has been advised of the availability of property inspections/tests. Unsatisfactory
                                            Home Conditions, Asbestos, Mold, Lead, Radon and other contaminants may exist in the
                                            Property of which the Broker or Agent is unaware. Suspected Contaminants and home condition
                                            may be identified with a typical air quality or home inspection(s). Broker recommends
                                            Purchaser obtain inspection(s) of Purchaser’s choice to better determine the presence of
                                            contaminants and home condition.
                                        </span>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600 }} />
                                        <span style={{ fontWeight: 600 }}>Select and Initial One: </span>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600 }} />
                                        <span> <input type="checkbox"
                                            checked={puchaseaggrement?.property_inspection_chk1} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, property_inspection_chk1: !puchaseaggrement?.property_inspection_chk1 })}
                                        /> <input type="text"
                                            value={puchaseaggrement?.property_inspection_chk1_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, property_inspection_chk1_value: e.target.value })}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />Purchaser
                                            elects NOT to obtain Property inspections.</span>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600 }} />
                                        <span> <input type="checkbox"
                                            checked={puchaseaggrement?.property_inspection_chk2} onChange={() => setPurchaseAgreement({ ...puchaseaggrement, property_inspection_chk2: !puchaseaggrement?.property_inspection_chk2 })}
                                        /> <input type="text"
                                            value={puchaseaggrement?.property_inspection_chk2_value} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, property_inspection_chk2_value: e.target.value })}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />Purchaser
                                            reserves the right to perform Property inspections.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600 }} />
                                        <span style={{ textDecoration: "underline" }}>If Purchaser has reserved the right to obtain property
                                            inspections, then the following provisions shall apply:</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>18.1 </span>Purchaser, at Purchaser’s expense, shall have
                                            the right to perform any inspections or investigation related to the Property that Purchaser
                                            desires, including a survey. If the condition of the Property is unsatisfactory in
                                            Purchaser’s subjective discretion, Purchaser shall provide Seller with:</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>18.1.1 </span> An Inspection Notice Addendum that sets out
                                            in writing any unsatisfactory physical items Purchaser requests Seller to correct;</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>18.1.2 </span> A Rejection Notice Addendum that notifies
                                            Seller that after inspection, Purchaser finds the Property to be in unsatisfactory condition
                                            (a rejection of the property).</span>
                                    </div>
                                </td>
                            </tr>

                        </tbody></table>
                </section>
                <section style={{ pageBreakAfter: "always" }}>
                    <table style={{ "width": "1100px", "margin": "0 auto", "background": "#fff", "padding": "15px" }}>
                        <tbody><tr>
                            <td>
                                <div>
                                    <span style={{ fontSize: "12px" }}>Great Plains Regional MLS, LLC Uniform Purchase Agreement –
                                        Cont</span>
                                </div>
                            </td>
                        </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>18.2 </span> To be effective, the Inspection Notice
                                            Addendum or Rejection Notice Addendum must be received by Seller no later than
                                            5:00 p.m. on the 14th calendar day after the acceptance date (“Inspection Objection
                                            Deadline”).
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ margin: "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>18.3 </span>1 If an Inspection Notice Addendum or
                                            Rejection Notice Addendum is not received by Seller by 5:00 p.m. on the 14th calendar
                                            day after the acceptance date (“Inspection Objection Deadline”), the Property shall be
                                            deemed to be satisfactory to Purchaser.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ margin: "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>18.4 </span>If a Rejection Notice Addendum is received by
                                            Seller by the Inspection Objection Deadline this Agreement shall automatically terminate.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>18.5 </span>If an Inspection Notice Addendum containing
                                            requests for action by Seller is received by Seller by the Inspection Objection Deadline and
                                            Purchaser and Seller have not agreed in writing as to what action is to be taken regarding
                                            the items by 5:00 p.m. on the 18th calendar day after the acceptance date of the Agreement
                                            (“Resolution Deadline”), this Agreement shall automatically terminate on the Resolution
                                            Deadline unless, before such termination, Purchaser’s written notice of withdrawal of the
                                            requirement that Seller correct the items contained in the Inspection Notice Addendum is
                                            received by Seller.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>18.6 </span> Upon termination of this Agreement under this
                                            Section 18, the Earnest Money, less amounts necessary to pay any expenses incurred by
                                            REALTOR® or escrow agent holding the Earnest Money, shall be refunded to Purchaser promptly,
                                            upon Purchaser providing written notification of the facts constituting termination to the
                                            party holding the Earnest Money, without further documentation being required, other than
                                            documentation of payment of known expenses incurred by or on behalf of Purchaser. Purchaser
                                            shall be responsible for payment of all inspections, surveys, engineering reports or for
                                            additional work performed at Purchaser’s request and shall pay for any damage which occurs
                                            to the real and personal property as a result of such activities. The provisions of this
                                            paragraph shall survive termination of the Agreement.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ margin: "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>18.7 </span>Purchaser does not, by acceptance of the real
                                            and personal property identified in this Agreement, waive, release or relinquish any right
                                            or claim Purchaser may have against Seller by reason of any misrepresentation, concealment
                                            or fraud.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ margin: "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>18.8 </span>If Purchaser chooses to have a radon test, and
                                            the results of the radon test show average radon levels below 4.0 picocuries per liter of
                                            air (pCi/L), such results shall be deemed acceptable to Purchaser.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>19</span>
                                        <span style={{ fontWeight: 600 }}> Purchaser’s Personal Inspection: </span>
                                        <span>
                                            This offer is based upon Purchaser’s personal inspection or investigation of the property
                                            and not upon any representation or warranties of condition by Seller or any limited agents
                                            involved in this transaction. <span style={{ fontWeight: 600, textDecoration: "underline" }}>If
                                                finished sq. ft., age, location of property lines, lot size, condition of improvements,
                                                protective covenants, designated school or school district, or other specific
                                                requirements are important to Purchaser’s decision to purchase, Purchaser acknowledges
                                                the limited agents have advised Purchaser to make or procure independent
                                                investigations.</span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>20</span>
                                        <span style={{ fontWeight: 600 }}>Utilities: </span>
                                        <span>
                                            Purchaser agrees to have all utilities transferred into their name, as of the date of
                                            Closing or possession, whichever is earlier. If there are any “Smart Home” or
                                            utility-connected devices controlled by online services on the Property, Seller agrees to
                                            remove the ability of Seller to control such devices and disable Seller’s own access.
                                            Purchaser agrees to reset all such devices to prevent such devices from connecting to
                                            Seller’s related accounts.
                                        </span>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>21</span>
                                        <span style={{ fontWeight: 600 }}>Condition of Property: </span>
                                        <span>
                                            Seller represents to the best of Seller's knowledge, information and belief, there are no
                                            material, latent defects in the Property nor any conditions present or existing with respect
                                            to the Property which may give rise to or create Environmental Hazards or Liabilities and
                                            there are no enforcement actions pending or threatened with respect to the Property or any
                                            conditions present on it, except as have been disclosed in writing to Purchaser. Seller
                                            agrees to maintain the landscaping, sprinkler system, heating, air conditioning, water
                                            heater, sewer, plumbing, electrical systems and any built-in appliances in functional and
                                            operable condition until delivery of possession, unless otherwise noted in the Seller
                                            Property Condition Disclosure Statement or specified herein. Seller will allow Purchaser to
                                            walk through Property within 2
                                            calendar days before Closing to confirm compliance with this Purchase Agreement. Following
                                            Closing, Purchaser shall
                                            be responsible for all maintenance and care for the Property.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>PROPERTY ADDRESS:
                                            <input type="text"
                                                value={offerdetails?.propertyAddress}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "500px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>© 2021 GREAT PLAINS REGIONAL MLS, LLC<br />
                                            Page 5 of 10<br />
                                            2/1/2021 Form 200
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                             
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                              value={offerdetails?.lead_firstname?.charAt(0)?.toUpperCase() + offerdetails?.lead_lastname?.charAt(0)?.toUpperCase()}
                                            
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "5px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>22</span>
                                        <span style={{ fontWeight: 600 }}>Rents, Leases and Tax Deferred Exchange: </span>
                                        <span>
                                            All leases and rents shall be current and not in default at Closing. Any tenant deposits and
                                            leases shall be assigned to Purchaser at no cost. All rents shall be prorated to date of
                                            Closing. Copies of all current leases shall be provided to the Purchaser within three (3)
                                            calendar days of acceptance of this Agreement. Purchaser and Seller each reserve the right
                                            to classify this transaction as a like-kind exchange under Section 1031 of the Internal
                                            Revenue Code. Each party shall cooperate with the other in such exchange, but shall not be
                                            required to incur additional expense or delays, by reason of the other party’s intended
                                            exchange.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>PROPERTY ADDRESS:
                                            <input type="text"
                                                value={offerdetails?.propertyAddress}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "500px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>© 2021 GREAT PLAINS REGIONAL MLS, LLC<br />
                                            Page 5 of 10<br />
                                            2/1/2021 Form 200
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                           
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text"
                                             value={offerdetails?.lead_firstname?.charAt(0)?.toUpperCase() + offerdetails?.lead_lastname?.charAt(0)?.toUpperCase()}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody></table>
                </section>
                <section style={{ pageBreakAfter: "always" }}>
                    <table style={{ "width": "1100px", "margin": "0 auto", "background": "#fff", "padding": "15px" }}>
                        <tbody><tr>
                            <td>
                                <div>
                                    <span style={{ fontSize: "12px" }}>Great Plains Regional MLS, LLC Uniform Purchase Agreement –
                                        Cont</span>
                                </div>
                            </td>
                        </tr>
                            <tr>
                                <td>
                                    <div style={{ fontSize: "15px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>23.</span>
                                        <span style={{ fontWeight: 600 }}> Homeowners Association and Protective Covenants: </span>
                                        <span>
                                            Purchaser acknowledges that the Property may be subject to protective covenants that govern
                                            Purchaser’s use of the Property, and that may be enforced by the homeowners association or
                                            its members. Purchaser can obtain a copy of the protective covenants from the designated
                                            title insurance company. Seller shall pay all homeowners and neighborhood association
                                            assessments levied and due as of Closing. Homeowners or neighborhood association dues shall
                                            be prorated to the date of Closing. Purchaser shall be responsible for all future homeowners
                                            or neighborhood association dues, if any.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ fontSize: "15px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>24.</span>
                                        <span style={{ fontWeight: 600 }}>Release of Information: </span>
                                        <span>
                                            Purchaser and Seller authorize the release by Broker and/or its agents of information
                                            including price, financing and Property information regarding the purchase of this Property
                                            to the Great Plains Regional MLS, LLC, its members and affiliates, its participants and
                                            government entities. Purchaser authorizes selling agent/broker to market the fact of the
                                            sale of this Property and related information including, but not limited to, the purchase
                                            price.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ fontSize: "15px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>25.</span>
                                        <span style={{ fontWeight: 600 }}>Government Required Actions and Disclosures: </span>
                                        <span>
                                            Purchaser and Seller authorize the release by Broker and/or its agents of information
                                            including price, financing and Property information regarding the purchase of this Property
                                            to the Great Plains Regional MLS, LLC, its members and affiliates, its participants and
                                            government entities. Purchaser authorizes selling agent/broker to market the fact of the
                                            sale of this Property and related information including, but not limited to, the purchase
                                            price.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ fontSize: "15px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>25.1 Seller Property Condition Disclosure:
                                        </span>Purchaser acknowledges receipt of Seller Property Condition Disclosure Statement
                                            unless not required by law.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ fontSize: "15px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>25.2 Lead Based Paint: </span>Was property built before
                                            1978? <input type="checkbox" // @ts-ignore  
                                                checked={offerdetails?.year_built == "Before 1978" ? true : false}
                                            />yes <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.year_built == "After 1978" ? true : false}
                                            />No. If yes, Purchaser and Seller
                                            must complete Disclosure of Information on Lead-Based Paint and/or Lead-Based Paint Hazards.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ fontSize: "15px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}> 25.3 SID: </span>Is the property located within an SID?
                                            <input type="checkbox" // @ts-ignore  
                                                checked={offerdetails?.sid}

                                            />yes <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.sid == false ? true : false}
                                            />No. Purchaser understands that this
                                            Property is located within S.I.D.
                                            <input type="text"
                                                value={puchaseaggrement?.sid_statement} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, sid_statement: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} />,If
                                            the Property is located within an SID, Purchaser acknowledges receipt of the most recently
                                            filed S.I.D. Statement and understands: (i) the Property is located within a sanitary and
                                            improvement district; (ii) sanitary and improvement districts are located outside the
                                            corporate limits of any municipality; (iii) residents of sanitary and improvement districts
                                            are not eligible to vote in municipal elections; and (iv) owners of Property located within
                                            sanitary and improvement districts have limited access to services provided by nearby
                                            municipalities until and unless the Property is annexed by the municipality.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ fontSize: "15px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}> 25.4 Fair Housing. </span>It is unlawful to discriminate
                                            against any person in the terms, conditions or privileges of sale, purchase or lease of a
                                            dwelling or in the provision of services or facilities in connection therewith because of
                                            race, color, religion, national origin, ethnic origin, familial status, sex, handicap,
                                            disability, or sexual orientation, under state or federal law, and, or in the City of Omaha,
                                            age discriminating is unlawful, against an individual forty (40) years of age or older.
                                            Local laws may apply to prohibit other kinds of discrimination. All references made (i) in
                                            any gender shall be deemed to have been made in all genders; (ii) in the singular or plural
                                            number shall be deemed to have been made, respectively, in the plural or singular number as
                                            well.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ fontSize: "15px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}> 25.5 Safety: </span>Seller agrees to install, at Seller’s
                                            expense, smoke detectors and carbon monoxide alarms as required by law.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ fontSize: "15px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}> 25.6 Affiliated Business Arrangements: </span> Purchaser
                                            and Seller acknowledge and understand that real estate brokers involved in this transaction
                                            may receive financial remuneration from the sale of title insurance or other forms of
                                            insurance or service as defined in the Affiliated Business Arrangement Disclosure, if
                                            applicable.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ fontSize: "15px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>26.</span>
                                        <span style={{ fontWeight: 600 }}>Insurance and Property Damage: </span>
                                        <span>
                                            Seller shall insure the property for fire, wind, hail, explosion, water or any other cause
                                            at no less than replacement cost until Closing. Risk of loss or damage to Property, prior to
                                            Closing, shall be the responsibility of Seller. If, following the Date of Offer, the
                                            Seller(s) has knowledge that the structure(s) on the Property are materially damaged; Seller
                                            shall immediately notify the Purchaser in writing of the damage. If storm damage is
                                            suspected but not actually known by Seller, Seller shall notify Purchaser and Seller and
                                            Purchaser shall have the right to have the Property inspected by an insurance adjustor or
                                            contractor, provided that such contractor must be licensed, if required, in the state,
                                            county, or city in which the Property is located. If damage is found, Seller shall be
                                            obligated to repair such damage prior to Closing unless Purchaser and Seller agree to allow
                                            repair to be made after Closing and Seller agrees to have held by the Escrow Agent one and
                                            one-half times the cost of repairs. Notwithstanding the foregoing, in the event that the
                                            cost of such repairs exceed 5% or , Purchaser may terminate this Agreement. Purchaser and
                                            Seller acknowledge and agree that there may be additional documentation and access needed to
                                            facilitate the repairs. As such, Seller and Purchaser agree to cooperate in executing
                                            documents necessary to complete the sale in a timely manner. Access to the property for
                                            repairs will not be unreasonably withheld.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ fontSize: "15px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>27.</span>
                                        <span style={{ fontWeight: 600 }}>Notice, Delivery and Time. </span>
                                        <span>
                                            Any notice permitted or required to be delivered to either party under this Agreement shall
                                            be sufficiently made via email or hand delivery to each party’s agent or Broker as named
                                            herein, regardless of whether such notice is reviewed. Any notice required to be made under
                                            this Agreement shall be required to be made before 5:00 P.M. of the prevailing local time of
                                            the Property. In measuring the number of days elapsed for any notice or other requirement
                                            under this Agreement, the counting of days shall exclude the day of the triggering event or
                                            notice.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>PROPERTY ADDRESS:
                                            <input type="text"
                                                value={offerdetails?.propertyAddress}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "500px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>© 2021 GREAT PLAINS REGIONAL MLS, LLC<br />
                                            Page 5 of 10<br />
                                            2/1/2021 Form 200
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                            
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                             value={offerdetails?.lead_firstname?.charAt(0)?.toUpperCase() + offerdetails?.lead_lastname?.charAt(0)?.toUpperCase()}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody></table>
                </section>
                <section style={{ pageBreakAfter: "always" }}>
                    <table style={{ "width": "1100px", "margin": "0 auto", "background": "#fff", "padding": "15px" }}>
                        <tbody><tr>
                            <td>
                                <div>
                                    <span style={{ fontSize: "12px" }}>Great Plains Regional MLS, LLC Uniform Purchase Agreement –
                                        Cont</span>
                                </div>
                            </td>
                        </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>28.</span>
                                        <span style={{ fontWeight: 600 }}>Modification in Writing: </span>
                                        <span>
                                            Any modification of the terms of this agreement must be in writing and signed by all
                                            parties.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>29.</span>
                                        <span style={{ fontWeight: 600 }}>Electronic Transaction Authorization: </span>
                                        <span>
                                            The undersigned agree that all documents bearing signatures, initials or other marks of
                                            acknowledgement by a Purchaser, Seller and/or Broker/agent relating to a real estate
                                            transaction contemplated under this Agreement, including offers, counteroffers and
                                            acceptances: (1) may be transmitted electronically, and/or may use digital signature
                                            technology which is compliant with state UETA and/or federal E-SIGN requirements and (2)
                                            that digital signatures as well as electronic copies of manual signatures, whether scanned,
                                            digital photograph, facsimile or other means of image reproduction shall be treated in all
                                            respects as originals, and (3) that they will submit all original signatures if requested by
                                            the other party. This Agreement and any addendums or modifications may be signed in
                                            counterparts and such counterparts shall be considered as one document.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>30.</span>
                                        <span style={{ fontWeight: 600 }}>Compensation of Selling Broker: </span>
                                        <span>
                                            Purchaser shall pay Selling Broker compensation of $
                                            <input type="text" // @ts-ignore  
                                                value={offerdetails?.warranty_cost}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />at Closing. The
                                            compensation will be collected in all cases except if Purchaser secures a loan that does not
                                            allow Purchaser to pay for such compensation. If this compensation is paid by Purchaser to
                                            Selling Broker, Seller and Purchaser agree that Selling Broker, which may be the same as the
                                            Listing Broker, or any cooperating broker may collect compensation from both Seller and
                                            Purchaser.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>31.</span>
                                        <span style={{ fontWeight: 600 }}>Arbitration and Mediation: </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>31.1 </span> Disputes: The term “Dispute” shall include,
                                            without limitation, any controversy, complaint, dispute, claim or disagreement relating to
                                            or arising out of the construction, interpretation, enforcement, or breach of the terms of
                                            this Purchase Agreement between Purchaser and Seller.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>31.2 </span> Mediation: In the event of any Dispute, any
                                            party to the Dispute may seek non-binding mediation in an attempt to resolve the dispute by
                                            giving fifteen (15) calendar days written notice of a request for such mediation to all
                                            other parties to the Dispute. The request for mediation must be made within three hundred
                                            sixty-five (365) calendar days after the party making the request knew, or exercising
                                            reasonable diligence and care, should have known, of the Dispute. In no case shall such
                                            request be made after the statute of limitations on a civil suit based on the Dispute would
                                            have run. Such mediation shall be administered by the American Arbitration Association and
                                            shall be conducted according to the American Arbitration Association’s Commercial Rules –
                                            Real Estate Industry Arbitration Rules (including a Mediation Alternative) or such other
                                            mediation service versed in real estate practices of the locality.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span style={{ fontWeight: 600 }}>31.3 Arbitration: Any Dispute that is not resolved by informal
                                            settlement or mediation shall be resolved exclusively by binding arbitration. Such
                                            arbitration shall be administered by the American Arbitration Association and shall be
                                            conducted according to the American Arbitration Association’s Commercial Rules – Real Estate
                                            Industry Arbitration Rules (Including a Mediation Alternative). The arbiter(s) shall apply
                                            substantive and procedural law of the jurisdiction of the Property to the arbitration
                                            proceeding. Arbitration shall be commenced by written demand made by any one or more of the
                                            parties to the Dispute given to all other parties to the Dispute. The demand for arbitration
                                            must be in writing and must be given by personal delivery or certified mail, return receipt
                                            requested, within three hundred sixty-five (365) days after the party making the demand
                                            knew, or exercising reasonable diligence and care, should have known, of the Dispute.
                                            Notwithstanding the previous sentence, in the case that the parties unsuccessfully attempt
                                            mediation to resolve a Dispute, the demand for arbitration shall be made within sixty (60)
                                            days of the final mediation session. However, in no case shall such demand be made after the
                                            statute of limitations on a civil suit based on the Dispute would have run. </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "12px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span style={{ fontWeight: 600 }}>The prevailing party shall be entitled to costs and fees of the
                                            arbitration and, in the discretion of the arbitrator who shall take
                                            into account the relative merits of the opponent’s case, the arbiter may award attorney’s
                                            fees and arbitration costs to the prevailing party.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>31.4 </span> <span style={{ fontWeight: 600, paddingLeft: "20px" }}>Provisional Remedies.</span>The filing of
                                            a judicial action to enable the reporting of a notice of pending action, for order of
                                            attachment, receivership, injunction, or other like provisional remedies, shall not
                                            constitute a waiver of mediation or arbitration under this provision, nor shall it
                                            constitute a breach of the duty to arbitrate.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>31.5 </span> <span style={{ fontWeight: 600, paddingLeft: "20px" }}>Exclusions.</span>The terms of this
                                            Section shall not apply to: 1) Foreclosure or other action or proceeding to enforce a deed
                                            of trust, mortgage or land contract; 2) the filing or enforcement of a construction or
                                            similar lien, or 3) an action filed and held in “Small Claims Court, as defined in Neb. Res.
                                            Stat 25-2801 to 2804, provided, however, that any attempt to transfer such a proceeding to
                                            county or district court shall make this Section applicable to such action.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span><span style={{ fontWeight: 600 }}>31.6 </span> <span style={{ fontWeight: 600, paddingLeft: "20px" }}>Waiver.</span> BY SIGNING THIS PURCHASE
                                            AGREEMENT, THE PARTIES AGREE THAT EVERY DISPUTE DESCRIBED ABOVE THAT IS NOT RESOLVED BY
                                            INFORMAL SETTLEMENT OR MEDIATION WILL BE DECIDED EXCLUSIVELY BY ARBITRATION AND THAT ANY
                                            ARBITRATION DECISION WILL BE FINAL AND BINDING. THE PARTIES AGREE THAT THEY WILL RECEIVE ALL
                                            THE RIGHTS AND BENEFITS OF ARBITRATION BUT
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>PROPERTY ADDRESS:
                                            <input type="text"
                                                value={offerdetails?.propertyAddress}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "500px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>© 2021 GREAT PLAINS REGIONAL MLS, LLC<br />
                                            Page 5 of 10<br />
                                            2/1/2021 Form 200
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                        
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                             value={offerdetails?.lead_firstname?.charAt(0)?.toUpperCase() + offerdetails?.lead_lastname?.charAt(0)?.toUpperCase()}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody></table>
                </section>
                <section style={{ pageBreakAfter: "always" }}>
                    <table style={{ width: "1100px", margin: "0 auto", background: "#fff", padding: "15px" }}>
                        <tbody>
                            <tr>
                                <td>
                                    <div>
                                        <span>ARE GIVING UP RIGHTS THEY MIGHT HAVE TO LITIGATE THOSE CLAIMS AND DISPUTES IN A COURT OR
                                            JURY TRIAL, OR TO PARTICIPATE AS A REPRESENTATIVE OR MEMBER OF ANY CLASS OF CLAIMANTS IN
                                            CONNECTION WITH ANY SUCH DISPUTES. NO PARTY TO THIS AGREEMENT, WHETHER REALTOR® OR SELLER,
                                            SHALL BE ENTITLED TO JOIN OR CONSOLIDATE DISPUTES BY OR AGAINST OTHERS IN ANY ARBITRATION,
                                            OR TO INCLUDE IN ANY ARBITRATION ANY DISPUTE AS A REPRESENTATIVE OR MEMBER OF A CLASS, OR TO
                                            ACT IN ANY ARBITRATION IN THE INTEREST OF THE GENERAL PUBLIC OR IN ANY PRIVATE ATTORNEY
                                            GENERAL CAPACITY.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600 }}>
                                            <input type="checkbox" /> Section 31 is hereby waived by all parties if this Section Initialed
                                            <span style={{ paddingLeft: "30px" }}>
                                                Purchaser(s) Initials:
                                                {/* @ts-ignore   */}
                                                <input type="text" value={offerdetails?.lead_firstname?.charAt(0)?.toUpperCase() + offerdetails?.lead_lastname?.charAt(0)?.toUpperCase()}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />
                                                <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />
                                            </span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>32</span>
                                        <span><span style={{ fontWeight: 600 }}>Offer Expiration: </span> This offer to purchase is
                                            subject to acceptance by Seller on or before 
                                            <input type="text" 
                                            value={puchaseaggrement?.offer_expiration_date} onChange={(e)=>setPurchaseAgreement({...puchaseaggrement,offer_expiration_date:e.target.value})}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "400px" }} />,20
                                            <input type="text" 
                                             value={puchaseaggrement?.offer_expiration_at} onChange={(e)=>setPurchaseAgreement({...puchaseaggrement,offer_expiration_at:e.target.value})}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />,at
                                            <input type="text" 
                                             value={puchaseaggrement?.offer_expiration_clock} onChange={(e)=>setPurchaseAgreement({...puchaseaggrement,offer_expiration_clock:e.target.value})}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />o’clock
                                            <input type="text" 
                                             value={puchaseaggrement?.m_prevailing_localtime} onChange={(e)=>setPurchaseAgreement({...puchaseaggrement,m_prevailing_localtime:e.target.value})}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />. M.,
                                            prevailing local time.
                                        </span>
                                    </div>
                                </td>
                            </tr> */}
                            {/* <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>33</span>
                                        <span style={{ fontWeight: 600 }}>
                                            List of Attachments and Addenda, and Disclosures. Purchaser and Seller acknowledge delivery
                                            and receipt of the following:
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}>33</span>
                                        <span style={{ fontWeight: 600 }}>
                                            List of Attachments and Addenda, and Disclosures. Purchaser and Seller acknowledge delivery
                                            and receipt of the following:
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span style={{ fontWeight: 600 }}>
                                            Addenda
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span style={{ fontWeight: 600 }}>
                                            HUD/FHA/VA Mortgage Addendum
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span style={{ fontWeight: 600 }}>
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "950px" }} />,
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span style={{ fontWeight: 600 }}>
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "950px" }} />,
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span style={{ fontWeight: 600 }}>
                                            Disclosures and Attachments Provided Between Purchaser and Seller
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span>
                                            Seller Property Condition Disclosure Statement Signed and Dated
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />,
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span>
                                            Disclosure of Information on Lead-Based Paint and/or Lead-Based Paint Hazards
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span>
                                            Limited Dual Agency Agreement
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span>
                                            S.I.D. Statement
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span>
                                            Preapproval/Prequalification Letter
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span>
                                            FHA Addendum
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span>
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "950px" }} />,
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span>
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "950px" }} />,
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span style={{ fontWeight: 600 }}>
                                            Checklist of Documents provided to Purchaser from Purchaser’s Broker
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span>
                                            Affiliated Business Arrangement Disclosure
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span>
                                            Wire Fraud Notice
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }}><input type="checkbox" /></span>
                                        <span>
                                            <input type="text" style={{ outline: "none", border: "none", borderBottom: "1px solid black", "width": "950px" }} />,
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px" }} />
                                        <span>
                                            The undersigned parties executed this Agreement and each individual executing this Agreement
                                            on behalf of an entity represents and warrants that he or she is duly authorized to do so.
                                        </span>
                                    </div>
                                </td>
                            </tr> */}
                            <tr>
                                <td>
                                    <div style={{ "margin": "2px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, paddingRight: "20px", WebkitTextDecorationLine: "underline", textDecoration: "underline" }}>THIS CONTRACT
                                            CONTAINS AN ARBITRATION PROVISION UNLESS WAIVED IN SECTION 31 WHICH MAY BE ENFORCED BY THE
                                            PARTIES.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table style={{ "width": "100%" }}>
                                        <tbody><tr>
                                            <td>
                                                <span style={{ paddingRight: "20px" }}>Purchaser:</span>
                                                <img id="seller1_value" src={user === "client" ? (val || puchaseaggrement?.purchaser1) : puchaseaggrement?.purchaser1}
                                                    className='text_input_soil_add' />
                                            </td>
                                            <td> <span style={{ paddingRight: "20px" }}>Purchaser:</span>
                                                {/* <img id="seller1_value" src={puchaseaggrement?.purchaser2}
                                            className='text_input_soil_add' /> */}
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table style={{ "width": "100%" }}>
                                        <tbody><tr>
                                            <td>
                                                <span style={{ paddingRight: "20px" }}>
                                                    <input type="text"  // @ts-ignore  
                                                        value={offerdetails?.leadName} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaser1_name_printed: e.target.value })}
                                                        style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "450px" }} />
                                                </span>
                                            </td>
                                            <td><span>
                                                <input type="text"
                                                    value={puchaseaggrement?.purchaser2_name_printed} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaser2_name_printed: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "450px" }} />
                                            </span></td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table style={{ "width": "100%" }}>
                                        <tbody><tr>
                                            <td>
                                                <span>Purchaser’s Name (Printed)</span>
                                            </td>
                                            <td><span>Purchaser’s Name (Printed)</span></td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table style={{ "width": "100%" }}>
                                        <tbody><tr>
                                            <td>
                                                <span>Address: <input type="text"
                                                    value={puchaseaggrement?.purchaser1_address} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaser1_address: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "400px" }} /></span>
                                            </td>
                                            <td>
                                                <span>Address: <input type="text"
                                                    value={puchaseaggrement?.purchaser2_address} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaser2_address: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "400px" }} /></span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table style={{ "width": "100%" }}>
                                        <tbody><tr>
                                            <td>
                                                <span>City: <input type="text"
                                                    value={puchaseaggrement?.purchaser1_city} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaser1_city: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} />State:<input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />Zip:<input type="text"
                                                        value={puchaseaggrement?.purchaser1_zip} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaser1_zip: e.target.value })}
                                                        style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "80px" }} /></span>
                                            </td>
                                            <td>
                                                <span>City: <input type="text"
                                                    value={puchaseaggrement?.purchaser2_city} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaser2_city: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} />State:<input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />Zip:<input type="text"
                                                        value={puchaseaggrement?.purchaser2_zip} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaser2_zip: e.target.value })}
                                                        style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "80px" }} /></span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table style={{ "width": "100%" }}>
                                        <tbody><tr>
                                            <td>
                                                <span>Phone: <input type="text"
                                                    value={puchaseaggrement?.purchaser1_phone} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaser1_phone: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "300px" }} /></span>
                                            </td>
                                            <td>
                                                <span>Phone: <input type="text"
                                                    value={puchaseaggrement?.purchaser2_phone} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaser2_phone: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "300px" }} /></span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "4px 0px 0px 0px" }}>
                                        <span>
                                            Purchaser acknowledges receipt of a signed copy of this Purchase Agreement, as well as
                                            Estimated Purchaser’s Closing Cost Statement if
                                            required by law.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ borderBottom: "3px solid black" }}>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600 }}>NAMES FOR DEED (Purchaser retains the right to change prior to
                                            Closing)</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span>NAME(S) FOR DEED <input type="text"
                                            value={puchaseaggrement?.nameof_deed} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, nameof_deed: e.target.value })}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "900px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ textAlign: "center" }}>
                                        <span><input type="checkbox"  // @ts-ignore  
                                            checked={offerdetails?.deed_Status?.companyname === "Single Individual" ? true : false}
                                        />Single Individual(s) <input type="checkbox"  // @ts-ignore  
                                            checked={offerdetails?.deed_Status?.companyname === "Married Individual" ? true : false}
                                            />Married Individual(s)
                                            <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.deed_Status?.companyname === "A Married Couple" ? true : false}
                                            />A Married Couple <input type="checkbox"  // @ts-ignore  
                                                checked={offerdetails?.deed_Status?.companyname === "Other" ? true : false}
                                            />Other</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>PROPERTY ADDRESS:
                                            <input type="text"
                                                value={offerdetails?.propertyAddress}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "500px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>© 2021 GREAT PLAINS REGIONAL MLS, LLC<br />
                                            Page 5 of 10<br />
                                            2/1/2021 Form 200
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                             
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                             value={offerdetails?.lead_firstname?.charAt(0)?.toUpperCase() + offerdetails?.lead_lastname?.charAt(0)?.toUpperCase()}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody></table>
                </section>
                <section style={{ pageBreakAfter: "always" }}>
                    <table style={{ "width": "1100px", "margin": "0 auto", "background": "#fff", "padding": "15px" }}>
                        <tbody>

                            <tr>
                                <td>
                                    <div style={{ borderBottom: "3px solid black" }}>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600 }}>PURCHASER AGENT INFO</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td> <input type="text"
                                                value="Milford Real Estate"
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span> REALTOR® (Company Name), Broker</span>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    value="Karie Milford/Ben Merwald"
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>AGENT NAME (Printed)</span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td> <input type="text"
                                                value="1822N 164 Plaza"
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} defaultValue="1815 N 169th Plaza, Suite A, Omaha, NE 68118" />
                                                <span> OFFICE ADDRESS</span>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    value="karie@milford.com/ben.merwald@milford.com"
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>AGENT E-MAIL ADDRESS</span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td> <input type="text"
                                                value="402-880-0202"
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} defaultValue="1815 N 169th Plaza, Suite A, Omaha, NE 68118" />
                                                <span> OFFICE MLS ID #</span>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    value={puchaseaggrement?.office_mls_id} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, office_mls_id: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} defaultValue={101584} />
                                                <span>AGENT MLS ID # / AGENT NREC LICENSE #</span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td> <input type="text"
                                                value={puchaseaggrement?.office_phone} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, office_phone: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} defaultValue="1815 N 169th Plaza, Suite A, Omaha, NE 68118" />
                                                <span>OFFICE PHONE #</span>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    value={puchaseaggrement?.agent_phone} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, agent_phone: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} defaultValue="-880-0202" />
                                                <span>AGENT PHONE #</span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ borderBottom: "3px solid black" }}>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ border: "2px solid black", width: "fit-content", padding: "5px 50px", "margin": "auto", textAlign: "center" }}>
                                        <span>SELLER ACCEPTANCE</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "10px 0px 0px 0px" }}>
                                        <span>The Seller, whether one or more, accepts the foregoing offer to purchase on
                                            <input type="text"
                                                value={puchaseaggrement?.offer_puchaseon} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, offer_puchaseon: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "300px" }} />, 20
                                            <input type="text"
                                                value={puchaseaggrement?.offer_puchaseon_year} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, offer_puchaseon_year: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "50px" }} />, at
                                            <input type="text"
                                                value={puchaseaggrement?.offer_puchaseon_oclock} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, offer_puchaseon_oclock: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />o’clock
                                            <input type="text"
                                                value={puchaseaggrement?.offer_puchaseon_m_prevailing_localtime} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, offer_puchaseon_m_prevailing_localtime: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />. M.,
                                            prevailing local time, on the terms stated and agrees to convey title to the Property,
                                            deliver possession, and perform all the terms and conditions set forth, except as follows:
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "10px 0px 0px 0px" }}>
                                        <span><input type="text"
                                            value={puchaseaggrement?.comments} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, comments: e.target.value })}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100%" }} />
                                        </span>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <div style={{ "margin": "10px 0px 0px 0px" }}>
                                        <span>Seller acknowledges receipt of a copy of this Agreement with all identified addenda and,
                                            if required by law, an Estimated Seller’s Closing Statement. The undersigned Seller executes
                                            this agreement as of the date set forth above.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "10px 0px 0px 0px" }}>
                                        <span style={{ fontWeight: 600, textDecoration: "underline" }}>
                                            THIS CONTRACT CONTAINS AN ARBITRATION PROVISION IN SECTION 31 UNLESS WAIVED WHICH MAY BE
                                            ENFORCED BY THE PARTIES.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td>
                                                <span>Seller:
                                                    <img id="seller1_value" src={user === "seller" ? (val || puchaseaggrement?.seller1) : puchaseaggrement?.seller1}
                                                        className='text_input_soil_add' />
                                                </span>
                                            </td>
                                            <td>
                                                <span>Seller:<input type="text"
                                                    value={puchaseaggrement?.seller2} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, seller2: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "450px" }} /></span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input type="text"
                                        value={puchaseaggrement?.seller1_name} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, seller1_name: e.target.value })}
                                        style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} /><span>Seller’s Name (Printed)</span><table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td> <input type="text"
                                                value={puchaseaggrement?.seller2_name} onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, seller2_name: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>Seller’s Name (Printed)</span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "margin": "10px 0px 0px 0px" }}>
                                        If Seller is a married individual, the Seller’s spouse will be required to sign the Deed and other
                                        closing documents.
                                        Seller is: <input type="checkbox"
                                            checked={puchaseaggrement?.seller_status == "Single Individual" ? true : false}
                                            onChange={() => setPurchaseAgreement({ ...puchaseaggrement, seller_status: "Single Individual" })}
                                        />Single Individual(s) <input type="checkbox"
                                            checked={puchaseaggrement?.seller_status == "Married Individual" ? true : false}
                                            onChange={() => setPurchaseAgreement({ ...puchaseaggrement, seller_status: "Married Individual" })}
                                        />Married Individual(s)
                                        <input type="checkbox"
                                            checked={puchaseaggrement?.seller_status == "A Married Couple" ? true : false}
                                            onChange={() => setPurchaseAgreement({ ...puchaseaggrement, seller_status: "A Married Couple" })}
                                        /> A Married Couple <input type="checkbox"
                                            checked={puchaseaggrement?.seller_status == "A Legal Entity" ? true : false}
                                            onChange={() => setPurchaseAgreement({ ...puchaseaggrement, seller_status: "A Legal Entity" })}
                                        /> A Legal Entity.
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ borderTop: "3px solid black", "margin": "10px 0px 0px 0px" }}>
                                        <span style={{ fontSize: "20px", fontWeight: 600 }}>SELLER AGENT INFO</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td> <input type="text"
                                                value={puchaseaggrement?.selleragentinfo_companyname}
                                                onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, selleragentinfo_companyname: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span> REALTOR® (Company Name), Broker</span>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    value={puchaseaggrement?.selleragentinfo_agentname}
                                                    onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, selleragentinfo_agentname: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>AGENT NAME (Printed)</span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td> <input type="text"
                                                value={puchaseaggrement?.selleragentinfo_officeaddress}
                                                onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, selleragentinfo_officeaddress: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span> OFFICE ADDRESS</span>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    value={puchaseaggrement?.selleragentinfo_agentemailaddress}
                                                    onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, selleragentinfo_agentemailaddress: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>AGENT E-MAIL ADDRESS</span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td> <input type="text"
                                                value={puchaseaggrement?.selleragentinfo_mlsid}
                                                onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, selleragentinfo_mlsid: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span> OFFICE MLS ID #</span>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    value={puchaseaggrement?.selleragentinfo_agentmlsid}
                                                    onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, selleragentinfo_agentmlsid: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>AGENT MLS ID # / AGENT NREC LICENSE #</span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td> <input type="text"
                                                value={puchaseaggrement?.selleragentinfo_phone}
                                                onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, selleragentinfo_phone: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>OFFICE PHONE #</span>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    value={puchaseaggrement?.selleragentinfo_agentphone}
                                                    onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, selleragentinfo_agentphone: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>AGENT PHONE #</span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ borderTop: "3px solid black", "margin": "10px 0px 0px 0px" }}>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>PROPERTY ADDRESS:
                                         <input type="text" 
                                         value={offerdetails?.propertyAddress}
                                         style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "500px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px"}}>© 2021 GREAT PLAINS REGIONAL MLS, LLC<br />
                                            Page 5 of 10<br />
                                            2/1/2021 Form 200
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text"
                                              
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                             value={offerdetails?.lead_firstname?.charAt(0)?.toUpperCase() + offerdetails?.lead_lastname?.charAt(0)?.toUpperCase()}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody></table>
                </section>
                <section>
                    <table style={{ "width": "1100px", "margin": "0 auto", "background": "#fff", "padding": "15px" }}>
                        <tbody><tr>
                            <td>
                                <div>
                                    <span style={{ fontSize: "12px" }}>Great Plains Regional MLS, LLC Uniform Purchase Agreement –
                                        Cont</span>
                                </div>
                            </td>
                        </tr>
                            <tr>
                                <td>
                                    <div style={{ "border": "2px solid black", "width": "fit-content", "padding": "5px 50px", "margin": "auto", textAlign: "center" }}>
                                        <span style={{ fontWeight: 600 }}>PURCHASER ACCEPTANCE OF COUNTER OFFER</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span>
                                            The Purchaser, whether one or more, accepts the foregoing Seller’s counteroffer to purchase
                                            on <input type="date"
                                                value={puchaseaggrement?.purchaseacceptance_date}
                                                onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaseacceptance_date: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "200px" }} /> , 20
                                            <input type="text"
                                                value={puchaseaggrement?.purchaseacceptance_year}
                                                onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaseacceptance_year: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "50px" }} />, at
                                            <input type="text"
                                                value={puchaseaggrement?.purchaseacceptance_colck}
                                                onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaseacceptance_colck: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />o’clock
                                            <input type="text"
                                                value={puchaseaggrement?.purchaseacceptance_m_prevailingtime}
                                                onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purchaseacceptance_m_prevailingtime: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100px" }} />. M.,
                                            prevailing local time, on the terms stated and perform all the terms and conditions set
                                            forth, except as follows:
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span><input type="text"
                                            value={puchaseaggrement?.purhcaseacceptance_comments}
                                            onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purhcaseacceptance_comments: e.target.value })}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "100%" }} /></span>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <div>
                                        <span>Purchaser acknowledges receipt of a copy of this Agreement with all identified addenda
                                            and, if required by law, an Estimated Purchaser’s Closing Statement. The undersigned
                                            Purchaser executes this agreement as of the date set forth above.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, textDecoration: "underline" }}>THIS CONTRACT CONTAINS AN
                                            ARBITRATION PROVISION IN SECTION 31 UNLESS WAIVED WHICH MAY BE ENFORCED BY THE
                                            PARTIES.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table style={{ "width": "100%" }}>
                                        <tbody><tr>
                                            <td>
                                                <span style={{ paddingRight: "20px" }}>Purchaser:</span>
                                                <img id="seller1_value" src={user === "client" ? (val || puchaseaggrement?.purchaser1) : puchaseaggrement?.purchaser1}
                                                    className='text_input_soil_add' />
                                            </td>
                                            <td> <span style={{ paddingRight: "20px" }}>Purchaser:</span>
                                                {/* <span>
                                                    <input type="text" 
                                                     value={puchaseaggrement?.purhcaser_acceptance_puchaser2}
                                                     onChange={(e)=>setPurchaseAgreement({...puchaseaggrement,purhcaser_acceptance_puchaser2:e.target.value})}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "350px" }} />
                                                </span> */}
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td> <input type="text"
                                                value={puchaseaggrement?.purhcaser_acceptance_puchaser1_name}
                                                onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purhcaser_acceptance_puchaser1_name: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>Purchaser’s Name (Printed)</span>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    value={puchaseaggrement?.purhcaser_acceptance_puchaser2_name}
                                                    onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, purhcaser_acceptance_puchaser2_name: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>Purchaser’s Name (Printed)</span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ "border": "2px solid black", "width": "fit-content", "padding": "5px 50px", "margin": "auto", textAlign: "center" }}>
                                        <span style={{ fontWeight: 600 }}>SELLER ACCEPTANCE OF COUNTER OFFER</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span>The undersigned Seller (check one):</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ paddingLeft: "30px" }}>
                                        <span>□ accepts the terms above.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ paddingLeft: "30px" }}>
                                        <span>□ makes a counter offer with an attached addendum.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontWeight: 600, textDecoration: "underline" }}>
                                            THIS CONTRACT CONTAINS AN ARBITRATION PROVISION IN SECTION 31 UNLESS WAIVED WHICH MAY BE
                                            ENFORCED BY THE PARTIES.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table style={{ "width": "100%" }}>
                                        <tbody><tr>
                                            <td>
                                                <span style={{ paddingRight: "20px" }}>Purchaser:</span>
                                                <img id="seller1_value" src={user === "client" ? (val || puchaseaggrement?.purchaser1) : puchaseaggrement?.purchaser1}
                                                    className='text_input_soil_add' />
                                            </td>
                                            <td> <span style={{ paddingRight: "20px" }}>Purchaser:</span>
                                                {/* <img id="seller1_value" src={puchaseaggrement?.purchaser1}
                                            className='text_input_soil_add' /> */}
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table>
                                        <tbody><tr style={{ "margin": "10px 0px 0px 0px" }}>
                                            <td> <input type="text"
                                                value={puchaseaggrement?.seller_acceptance_puchaser1_name}
                                                onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, seller_acceptance_puchaser1_name: e.target.value })}
                                                style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>Purchaser’s Name (Printed)</span>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    value={puchaseaggrement?.seller_acceptance_puchaser2_name}
                                                    onChange={(e) => setPurchaseAgreement({ ...puchaseaggrement, seller_acceptance_puchaser2_name: e.target.value })}
                                                    style={{ "outline": "none", "border": "none", borderBottom: "1px solid black", "width": "500px" }} />
                                                <span>Purchaser’s Name (Printed)</span>
                                            </td>
                                        </tr>
                                        </tbody></table>
                                </td>
                            </tr>
                            
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px" }}>PROPERTY ADDRESS:
                                         <input type="text" 
                                         value={offerdetails?.propertyAddress}
                                         style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "500px" }} /></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div>
                                        <span style={{ fontSize: "12px"}}>© 2021 GREAT PLAINS REGIONAL MLS, LLC<br />
                                            Page 5 of 10<br />
                                            2/1/2021 Form 200
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text"
                                          
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                        <span style={{ "float": "right", fontSize: "12px" }}>
                                            Purchaser(s) Initials: <input type="text" 
                                             value={offerdetails?.lead_firstname?.charAt(0)?.toUpperCase() + offerdetails?.lead_lastname?.charAt(0)?.toUpperCase()}
                                            style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                            <input type="text" style={{ "outline": "none", "border": "none", borderBottom: "1px solid silver", "width": "100px" }} />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody></table>
                </section>
            </div>

            <React.Fragment>
         
                <div className="d-flex align-items-center justify-content-end mb-2 mr-2">
                <button onClick={send} className="btn primaryColorBtn">Submit
                        {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
                    </button>
                    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
                    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button>
                </div>
            </React.Fragment>

            <Esign
                canvasmodal={canvasmodal}
                setCanvasModal={setCanvasModal}
                htmlContent={htmlContent}
                setHtmlContent={setHtmlContent}
                selecteddocumentesign={selecteddocumentesign}
                setselectedDocumentEsign={setselectedDocumentEsign}
                type={"seller"}
            ></Esign>
        </>
    )
}
export default ReqPurchaseAggrement